export const fontsСonnecting = () => {
	window.addEventListener('load', () => {
		const link = document.createElement('link');
		link.rel = 'stylesheet';
		link.href = '/local/assets/fonts/fonts.css';
		document.head.appendChild(link);
	});
};